
import Vue from 'vue'
import { mapState } from 'vuex'
import { JcdcCalendar, JcdcLoadingPage } from '@/components/jcdc/index'

export default Vue.extend({
  name: 'StudentSchedule',
  components: { JcdcCalendar, JcdcLoadingPage },
  computed: {
    ...mapState('schedule', ['studentSchedule', 'loadingSchedule']),
    mobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
  },
})
